import React from 'react';
import PropTypes from 'prop-types';
import SvgText from 'components/svg-text';
import {LEFT, RIGHT, TOP} from 'constants/orient';
import * as ValueType from 'constants/value-type';
import {formatNumber} from 'common/formatters/number-formatter';
import styles from './index.css';

export default class LinearAxisTickLabel extends React.Component {
  static propTypes = {
    index: PropTypes.number,
    numTicks: PropTypes.number,
    orient: PropTypes.string,
    style: PropTypes.object,
    value: PropTypes.number,
    valueType: PropTypes.oneOf(Object.values(ValueType)),
    x: PropTypes.number,
    y: PropTypes.number,
  };

  static defaultProps = {
    index: 0,
    numTicks: 0,
    orient: '',
    style: {},
    value: 0,
    valueType: ValueType.NUMERIC,
    x: 0,
    y: 0,
  };

  getClassNameFromOrientation(orient, styleNames) {
    switch (orient) {
      case LEFT:
        return styleNames.Left;
      case RIGHT:
        return styleNames.Right;
      case TOP:
        return styleNames.Top;
      default:
        return '';
    }
  }

  getTextForType(text, valueType) {
    switch (valueType) {
      case ValueType.PERCENTAGE:
        return `${text}%`;
      default:
        return `${text}`;
    }
  }

  render() {
    const formattedValue = formatNumber(
      this.props.value,
      'number',

      // Axes require abbreviation starting at 1000.
      this.props.value >= 1000
        ? {
            average: true,
            mantissa: 2,
            thousandSeparated: true,
            trimMantissa: true,
          }
        : null,
    );
    const textForValueType = this.getTextForType(
      formattedValue,
      this.props.valueType,
    );
    const className = this.getClassNameFromOrientation(
      this.props.orient,
      styles,
    );
    return (
      <SvgText
        className={className}
        style={this.props.style}
        text={textForValueType}
        x={this.props.x}
        y={this.props.y}
      />
    );
  }
}
